export enum IncomeType {
  EMPLOYED = 'employed',
  OTHER = 'other',
}
